export interface TableSelectionVisibility {
  selectionMode: boolean;
  hasMultiActions: boolean;
  isBoardView: boolean;
  readOnly: boolean;
  hasSelectAllActions: boolean;
}

export function showSelectionColumn(v: TableSelectionVisibility): boolean {
  if (v.isBoardView) {
    return false;
  }
  return v.selectionMode || (v.hasMultiActions && !v.readOnly);
}

export function showActionsMenu(v: TableSelectionVisibility): boolean {
  return !v.selectionMode && v.hasMultiActions && !v.isBoardView && !v.readOnly;
}

export function showSelectAllAffordance(v: TableSelectionVisibility): boolean {
  if (v.isBoardView) {
    return false;
  }
  return v.selectionMode || v.hasSelectAllActions;
}
